import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@mui/styles';
import { Box, Divider, Typography } from '@mui/material';

import { Drawer } from '@components';

const useStyles = makeStyles(() => ({
  title: {
    fontWeight: 500,
    fontSize: '14px',
    marginBottom: '8px',
  },
  description: {
    color: '#696B6C',
    fontSize: '14px',
  },
}));

const TooltipDrawer = ({ title, children, description }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Drawer infoBtn>
      <Divider />
      {children ? (
        children
      ) : (
        <Box paddingX="20px" marginY="26px">
          <Typography className={classes.title}>{t(title)}</Typography>
          <Typography>{t(description)}</Typography>
        </Box>
      )}
    </Drawer>
  );
};

TooltipDrawer.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  description: PropTypes.string,
};

export default TooltipDrawer;
